// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4180) return "static/chunks/4180-14c8227e421b9b61.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2295":"c44f3486","5313":"59c6eb5a","6353":"reactPlayerPreview","7646":"a3319169"}[chunkId] || chunkId) + "." + {"10":"7eb055a6c293ee39","86":"4e2299c0ba624dfd","2295":"2d1c9fd2979abc1f","3304":"67a6abf9be3875b6","5313":"7a942dac6da5e40b","6353":"ef07907b8013e194","7646":"5705ca6745cbe5d6","8591":"41be40c386b6cdbf"}[chunkId] + ".js";
};